export default function Go_Concurrency () {
  return (
    <div>
      <h1>Go_Concurrency </h1>
      <p>Go Concurrency</p>
    </div>
  );
}